import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AddButton,
  BackButton,
  HelpButton,
  SaveButton,
} from "../../../components/btn/Buttons";
import PageHeading from "../../../components/PageHeading";
import SmallModal from "../../../components/modal/SmallModal";
import axios from "axios";
import { staffMasterAPI } from "../../../utils/apis";
import { toast } from "react-toastify";
import moment from "moment";
import PageLoading from "../../../components/PageLoading";
import { DeleteIcon } from "../../../utils/utils";
import TableNew from "../../../components/table/TableWithPagination";
import { Pagination3 } from "../../../components/pagination/pagination";
import { get_equipment_list, get_staff_list } from "../masterdataSlice";
import store from "../../../redux/store";
import { useSelector } from "react-redux";
import AddStaffMaster from "../../../components/AddComponent/MasterData/AddStaffMaster";
import UpdateStaffMaster from "../../../components/UpdateComponent/MasteraData/UpdateStaffMaster";
import usePaginationState from "../../../CustomHooks/usePaginationState";
import { setLoadingMain } from "../../../redux/slice/actionSlice";

export const StaffMaster = ({ data = false }) => {
  const childRef = useRef();

  const [open, setOpen] = useState(false);
  // const [openUpload, setOpenUpload] = useState(false);
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const { entries, setEntries, pageNo, setPageNo, totalCount, setTotalCount } =
    usePaginationState();
  const [flag, setFlag] = useState(false);

  const [showEdit, setShowEdit] = useState(false);
  const [EditItem, setEditItem] = useState({});

  // New Ref Functions

  const handleAddProduct = () => {
    childRef.current?.handleAddProduct();
  };

  const handleSaveProduct = () => {
    childRef.current?.handleSaveProduct();
  };

  // New Ref Functions End

  useEffect(() => {
    if (data) {
      store.dispatch(get_equipment_list());
    }
  }, []);

  const obj = {
    pageNo: pageNo,
    entries: entries,
    setTotalCount: setTotalCount,
  };

  const { staff_list, staff_loading } = useSelector(
    (state) => state.masterdata
  );
  const { user_id, emp_id, user_type } = useSelector((state) => state.other);

  const handleDeleteStaffMaster = async (deleteId) => {
    store.dispatch(setLoadingMain(true));
    const body = new FormData();
    body.append("action", "delete");
    body.append("agencyid", user_id);
    body.append("id", deleteId);
    if (emp_id) {
      body.append("emp_code", emp_id);
    }
    const response = await axios.post(staffMasterAPI, body);
    store.dispatch(setLoadingMain(false));
    setShowDeleteAlert(false);
    if (response.data.success) {
      toast(response.data.message, {
        position: "top-center",
      });
      if (staff_list?.length < 2) {
        setPageNo(pageNo - 1);
        store.dispatch(
          get_staff_list({
            pageNo: pageNo - 1,
            entries: entries,
            setTotalCount: setTotalCount,
          })
        );
      } else {
        store.dispatch(get_staff_list(obj));
      }
    }
  };

  useEffect(() => {
    store.dispatch(get_staff_list(obj));
  }, [pageNo, entries]);

  return (
    <div className="container">
      <PageHeading
        title={"STAFF MASTER"}
        right={
          <>
            {!data && (
              <AddButton
                onClick={() => {
                  setOpen(true);
                  handleAddProduct();
                }}
              />
            )}
            {open && <SaveButton title={"SAVE"} onClick={handleSaveProduct} />}
            {/* {!data && (
              <>
                <Button onClick={download_excel} title={"DOWNLOAD EXCEL"} />
                <Button
                  onClick={() => setOpenUpload(true)}
                  title={"UPLOAD EXCEL"}
                />
              </>
            )} */}

            <BackButton />
            <HelpButton
              link={[
                "https://youtu.be/4FzTz5cY6bc",
                "https://youtu.be/JcUiQNwM4QY",
              ]}
            />
          </>
        }
      />

      <AddStaffMaster open={open} obj={obj} setOpen={setOpen} ref={childRef} />

      <Pagination3
        totalCount={totalCount}
        pageNo={pageNo}
        setPageNo={setPageNo}
        entries={entries}
        setEntries={setEntries}
        search={false}
      >
        {staff_loading ? (
          <PageLoading />
        ) : (
          <TableNew
            mt={5}
            nodata={staff_list?.length !== 0 && !staff_loading ? false : true}
            headData={[
              "EMPLOYEE CODE",
              "EMPLOYEE NAME",
              "DATE OF BIRTH",
              "DESIGNATION",
              "ROLE",
              "DATE OF JOINING",
              "CREATED BY",
              "ACTIONS",
            ]}
            body={
              staff_list?.length != 0 &&
              staff_list?.map((item, i) => (
                <tr key={i}>
                  <td
                    style={{ cursor: "pointer" }}
                    className="bank_master_hover"
                    onClick={() => {
                      setEditItem({
                        ...item,
                        STAFF_TYPE: item?.STAFF_TYPE || 0,
                      });
                      setShowEdit(true);
                      if (item?.role_id == 0 && item?.STAFF_TYPE == 1) {
                        setFlag(true);
                      } else {
                        setFlag(false);
                      }
                    }}
                  >
                    {item?.EMP_CODE}
                  </td>
                  <td>{item?.EMP_NAME}</td>
                  <td>{moment(item?.DOB).format("DD/MM/YYYY")}</td>
                  <td>{item?.DESIGNATION}</td>
                  <td>{item?.ROLE}</td>
                  <td>{moment(item?.DOJ).format("DD/MM/YYYY")}</td>
                  <td>{item?.CREATED_NAME || "-"}</td>
                  <td>
                    {user_type == "admin" || item?.EMPLOYEE_CODE == emp_id ? (
                      <DeleteIcon
                        onClick={() => {
                          setDeleteId(item?.ID);
                          setShowDeleteAlert(true);
                        }}
                      />
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))
            }
          />
        )}
      </Pagination3>

      {/* {openUpload && (
        <SmallModal
          okBtnHide={false}
          isOpen={openUpload}
          setIsOpen={setOpenUpload}
          style={{ minWidth: "30rem" }}
          okbtn={setOpenUpload}
          title={"UPLOAD MASTER DATA"}
          mess={<UploadFile handle_click={(file) => upload_excel(file)} />}
        />
      )} */}

      {showDeleteAlert && (
        <SmallModal
          isOpen={showDeleteAlert}
          setIsOpen={setShowDeleteAlert}
          onClick={() => handleDeleteStaffMaster(deleteId)}
          title={"Confirm"}
          mess={"Are you sure? You want to delete"}
        />
      )}

      {showEdit && (
        <UpdateStaffMaster
          open={showEdit}
          setOpen={setShowEdit}
          data={data}
          flag={flag}
          obj={obj}
          setFlag={setFlag}
          EditItem={EditItem}
          setEditItem={setEditItem}
        />
      )}
    </div>
  );
};
